export default {
      id: "thumbs-up-usage",
      viewBox: "0 0 48 45",
      url: __webpack_public_path__ + "sprite.svg#thumbs-up",
      toString: function () {
        return this.url;
      }
    }